module.exports = __webpack_public_path__ + "static/media/check.390bf7b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/iconic/check.svg
// module id = 786
// module chunks = 0